import axios, {AxiosResponse} from 'axios'
import {
  IUserProfile,
  TUpdateEmailRequest,
  TUpdatePasswordRequest,
} from '../../../coreGlobal/models/user'
import {TStarProgressResponse, TStarResponse} from '../../../coreGlobal/models/franchise/franchise'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const PROFILE_URL = `${API_URL}/profile`
const FRANCHISE_URL = `${API_URL}/franchises`

const postProfilePhoto = async (photo: File) => {
  const formData = new FormData()
  formData.append('photo', photo)

  return axios
    .post(`${PROFILE_URL}/photo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const putProfilePhoto = async (data: IUserProfile) => {
  return axios
    .put(`${PROFILE_URL}/update`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const putProfileChangeEmail = async (data: TUpdateEmailRequest) => {
  return axios
    .put(`${PROFILE_URL}/change-email`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const putProfileChangePassword = async (data: TUpdatePasswordRequest) => {
  return axios
    .put(`${PROFILE_URL}/change-password`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const deleteProfilePhoto = async () => {
  return axios
    .delete(`${PROFILE_URL}/photo`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getStarsById = (id: number | string): Promise<TStarResponse> => {
  return axios
    .get(`${FRANCHISE_URL}/${id}/stars`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getProfile = async (): Promise<TStarProgressResponse> => {
  return axios
    .get(`${PROFILE_URL}`)
    .then((response: any) => response.data)
    .then((response: any) => response.star_progress)
}

export {
  postProfilePhoto,
  putProfilePhoto,
  putProfileChangeEmail,
  putProfileChangePassword,
  deleteProfilePhoto,
  getStarsById,
  getProfile,
}
